<template>
  <v-dialog
    v-model="show"
    max-width="80%"
    :transition="transition"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
  >

    <v-card
    >
      <v-toolbar
        dark
        color="primary"
        column
        flat
        style="border-bottom: 1px solid #f5f5f5; background-color:white; margin:0px; padding:0px;"
      >

        <v-toolbar-title>Patient Search</v-toolbar-title>

      </v-toolbar>
      <v-toolbar v-if="patientRequests">
        <v-toolbar-title>
          {{selectedPatientString}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="backToPatients" icon><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-toolbar v-if="!patientRequests" class="pt-2" flat color="#f5f5f5">
              <v-text-field
                v-model="patientFields.lastName"
                label="Last Name"
                outline
                persistent-hint
                autofocus
                @keyup.enter="search"
                clearable
              >
              </v-text-field>
              <v-text-field
                class="ml-4"
                label="First Name"
                v-model="patientFields.firstName"
                outline
                @keyup.enter="search"
                clearable
              >
              </v-text-field>

              <v-text-field
                class="ml-4"
                label="Patient ID"
                v-model="patientFields.id"
                outline
                @keyup.enter="search"
                clearable
              >
              </v-text-field>

              <v-text-field
                class="ml-4"
                outline
                v-model="patientFields.DOB"
                label="Date of Birth"
                hint="MM/DD/YYYY format"
                persistent-hint
                mask="##/##/####"
                @keyup.enter="search"
                clearable
              ></v-text-field>
           </v-toolbar>

      <v-card-text style="height:720px;" class="pa-0">

        <!-- Patient Search datatable -->
        <v-data-table
          v-if="patientSearchResults && !patientRequests"
            :headers="headers"
            :items="patientSearchResults"
            flat
            class="flat mb-2 table-border mt-4"
            scrollable
            :rows-per-page-items="[50]"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>{{ props.item.firstName + ' ' + props.item.lastName }}</td>
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.gender }}</td>
                <td>{{ formatDate(props.item.birthdate) }}</td>
                <td align="right">
                  <v-btn
                    @click="viewRequests(props.item)"
                    depressed
                    color="primary"
                    outline
                    dark
                  >View Requests</v-btn>

                </td>
              </tr>
            </template>

          </v-data-table>

        <!-- Patient Requests datatable -->
        <v-layout
          v-if="patientRequests"
          column
        >
          <!-- Title -->
          <v-layout
            row
            class="mt-4"
          >
            <v-layout class="table-header">Patient Requests List</v-layout>
            <v-btn
              depressed
              color="grey"
              outline
              @click="backToPatients"
            >Back</v-btn>
            <v-btn
              depressed
              color="primary"
              @click="selectWithoutRequest"
            >Select Patient</v-btn>
          </v-layout>

          <v-data-table
            :headers="requestHeaders"
            :items="patientRequests"
            flat
            class="flat mb-2 table-border"
            scrollable
            :rows-per-page-items="[5]"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>{{ props.item.providerNameOverride }}</td>
                <td>{{ props.item.providerAddressOverride.line1 }} {{ props.item.providerAddressOverride.city }} {{ props.item.providerAddressOverride.state }} {{ props.item.providerAddressOverride.zip }}</td>
                <td>{{ formatDate(props.item.start) }} - {{ formatDate(props.item.end) }}</td>
                <td align="right">
                  <v-btn
                    @click="selectRequest(props.item)"
                    depressed
                    color="primary"
                    outline
                  >Select Request</v-btn>
                </td>
              </tr>
            </template>

          </v-data-table>
        </v-layout>

      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
import Avatar from '@/core/components/Avatar'
import DialogMixin from '@/core/mixins/DialogMixin'
import HelperMixin from '@/core/mixins/HelperMixin'
import bus from '@/core/helpers/bus'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'OneConfirmDialog',
  mixins: [DialogMixin, HelperMixin],
  components: {
    Avatar
  },
  data() {
    return {
      // selected patient string
      selectedPatientString: null,
      // State control
      searching: false,

      // Patient Data Table
      isLoading: false,
      resultsEmpty: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'fullName'
        },
        {
          text: 'Patient ID',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Gender',
          align: 'left',
          sortable: false,
          value: 'gender'
        },
        {
          text: 'Birth date',
          align: 'left',
          sortable: false,
          value: 'birthdateString'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'action'
        }
      ],

      // Patient Requests Datatable
      requestHeaders: [
        {
          text: 'Provider',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        {
          text: 'Address',
          align: 'left',
          sortable: false,
          value: 'date'
        },
        {
          text: 'Dates of Service',
          align: 'left',
          sortable: false,
          value: 'date'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'action'
        }
      ],

      // Search Fields
      patientFields: {
        firstName: '',
        lastName: '',
        id: '',
        DOB: ''
      },

      // Selected Values
      selectedPatient: null,
      selectedRequest: null
    }
  },
  methods: {
    ...mapActions('admin', ['getPatients', 'getPatientRequests']),
    ...mapMutations('admin', ['setPatientRequest']),
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    selectPatient(patient) {
      const vm = this
      vm.$emit('selectPatient', patient)
      this.close()
    },
    formatDate(timestamp) {
      let d = new Date(timestamp * 1000)
      let MyDateString =
        ('0' + (d.getMonth() + 1)).slice(-2) +
        '/' +
        ('0' + d.getDate()).slice(-2) +
        '/' +
        d.getFullYear()
      return MyDateString
    },
    close() {
      this.backToPatients()
      this.searching = false
      this.cancel()

      this.toast('success', 'Patient and request set')
    },
    search() {
      this.backToPatients()
      this.searching = true

      this.getPatients({
        id: this.patientFields.id,
        firstName: this.patientFields.firstName,
        lastName: this.patientFields.lastName,
        DOB: this.patientFields.DOB
      })
    },
    viewRequests(patient) {
      this.selectedPatientString = patient.firstName + ' ' + patient.lastName + ' ' + patient.gender.charAt(0) + ' ' + this.formatDate(patient.birthdate)

      this.selectedPatient = patient.id
      this.getPatientRequests({ patientID: patient.id })
    },
    backToPatients() {
      this.selectedPatient = null
      this.selectedRequest = null
      this.setPatientRequest(null)
    },
    selectRequest(request) {
      this.selectedRequest = request.id
      this.$emit('valuesEmit', {
        patient: this.selectedPatient,
        request: this.selectedRequest,
        provider: request.provider,
        patientDisplayString: this.selectedPatientString
      })
      this.close()
    },
    selectWithoutRequest() {
      this.$emit('valuesEmit', {
        patient: this.selectedPatient,
        patientDisplayString: this.selectedPatientString
      })
      this.close()
    }
  },
  computed: {
    ...mapState('admin', ['patientSearchResults', 'patientRequests']),
    showBuilding() {
      return this.options.unit && this.options.building
    },
    combinedFieldsObj() {
      const patient = this.patientFields
      return patient.firstName + patient.lastName + patient.id + patient.DOB
    }
  }
}
</script>

<style scoped>
.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  text-align: center;
  color: #52535f;
}

.sharingLink {
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 20px;
  text-align: center;
  color: #52535f;
  word-wrap: break-word;
}

.table-border {
  border: 1px solid #f5f5f5;
}

.table-header {
  font-size: 16px;
  font-weight: 300px;
  color: #52535f;
}
</style>


// WEBPACK FOOTER //
// src/components/dialogs/PatientSearchDialog.vue